// Generated by purs version 0.11.7
"use strict";
var Data_Foldable = require("../Data.Foldable");
var Data_Functor = require("../Data.Functor");
var Data_Ord = require("../Data.Ord");
var Data_Set = require("../Data.Set");
var FRP_Behavior = require("../FRP.Behavior");
var FRP_Event = require("../FRP.Event");
var FRP_Event_Keyboard = require("../FRP.Event.Keyboard");
var Prelude = require("../Prelude");
var keys = FRP_Behavior.behavior(function (e) {
    return Data_Functor.map(FRP_Event.functorEvent)(function (v) {
        return v.value(Data_Set.fromFoldable(Data_Foldable.foldableArray)(Data_Ord.ordInt)(v.keys));
    })(FRP_Event_Keyboard.withKeys(e));
});
var key = function (k) {
    return Data_Functor.map(FRP_Behavior.functorABehavior(FRP_Event.functorEvent))(Data_Set.member(Data_Ord.ordInt)(k))(keys);
};
module.exports = {
    keys: keys,
    key: key
};



//////////////////
// WEBPACK FOOTER
// ./output/FRP.Behavior.Keyboard/index.js
// module id = 325
// module chunks = 0